<mode-header
  [breadcrumbs]="emptyReportBreadCrumbs$ | async"
  [workspace]="orgContext$ | async"
></mode-header>
